<template>
  <section class="max-w-grid-width">
    <h1 class="TitelXL"><span class="thuepackschriftzug">ThüPack </span>
      <span class="thuepackGmbhschriftzug"> GmbH </span></h1>
    <h1>Ihr Partner für Verpackungslösungen mit 25 Jahren Erfahrung</h1>
    <div class="row my-5">
      <div class="col-md-4">
        <img src="../assets/Katze.jpg" alt="ltb-logo" class="img-fluid rundeEcken" />
        <h4>Für jedes Problem <br/>- die richtige Verpackung</h4>
      </div>
      <div class="col-md-8 mainText">
        <p>
          Seit über 25 Jahren steht <span class="thuepackschriftzug">ThüPack </span> für Qualität, Zuverlässigkeit und individuelle
          Lösungen rund um Verpackungsmaterialien und Verpackungszubehör.
        </p>
        <p>
          Als erfahrenes Familienunternehmen vereinen wir Tradition mit Innovation und
          sind Ihr vertrauensvoller Partner in ganz Deutschland und europaweit.
        </p>
        <p>
          Ob Kartonagen, Füllmaterial, Klebebänder oder Speziallösungen – wir liefern
          Ihnen genau das, was Sie für den sicheren Versand und die professionelle
          Lagerung Ihrer Produkte benötigen.
        </p>
        <p>
          Persönliche Beratung, kurze Lieferzeiten und ein umfassendes Sortiment machen
          <span class="thuepackschriftzug">ThüPack </span> zur ersten Wahl, wenn es um Verpackung geht.
        </p>
        <p>Gerne übernehmen wir auch die Lagerlogistik für Ihr Verpackungsmaterial und beliefern Sie Just-In-Time auf Abruf.</p>
        <p class="fw-bold"></p>
      </div>
    </div>
    <h2><span class="thuepackschriftzug">ThüPack </span>  – Verpackung mit Verantwortung. Für heute. Für morgen. Für Europa.</h2>
    <div class="row my-5">
      <div class="col-md-4">
        <img
          src="../assets/Maschine1.png"
          alt="ltb-logo"
          class="img-fluid rundeEcken mb-3"
        />
        <img src="../assets/Maschine2.png" alt="ltb-logo" class="img-fluid rundeEcken" />
        <h4>Maßgefertigt für Ihr Produkt</h4>
      </div>
      <div class="col-md-8 mainText">
        <p>
          Willkommen bei Ihrem zuverlässigen Partner für Wellkartonverpackungen und
          Verpackungszubehör direkt aus dem Herzen Deutschlands, aus dem wunderschönen
          Thüringen.
        </p>
        <p>
          Wir stehen für Qualität, Präzision und Nachhaltigkeit, gefertigt auf
          hochmodernen Maschinen und mit dem Anspruch, Ihre Produkte sicher, effizient und
          ansprechend zu verpacken.
        </p>
        <p>
          Ob maßgeschneiderte Wellkartonlösungen, funktionales Verpackungszubehör oder
          individuelle Sonderanfertigungen, unser erfahrenes Team entwickelt Verpackungen,
          die perfekt auf Ihre Anforderungen abgestimmt sind.
        </p>
        <p>
          Dabei setzen wir auf neueste Technologien, kurze Wege und eine umweltbewusste
          Produktion.
        </p>
        <p>
          Unsere zentrale Lage in Thüringen ermöglicht schnelle Lieferzeiten und
          persönliche Betreuung für Kunden in ganz Deutschland und darüber hinaus.
        </p>
        <p>
          Vertrauen Sie auf Kompetenz, Innovation und Service, die Ihre Produkte ins
          rechte Licht rücken.
        </p>
        <p>
          Verpackung ist mehr als Schutz – sie ist Teil Ihres Erfolgs. Wir verpacken, was
          Ihnen wichtig ist. Made in Thüringen.
        </p>
       
        <p class="fw-bold"></p>
      </div>
    </div>
  </section>
</template>
